import React from "react";
import { Alert } from "react-bootstrap";

export default function ErrorList(props) {
  const { errorMessages, className } = props;

  if (!errorMessages || errorMessages.length === 0) {
    return <div />;
  }

  const errorListEntries = errorMessages.map((message, index) => (
    <li key={`em-${index}`}>{message}</li>
  ));

  return (
    <Alert bsStyle="danger" className={className}>
      <ul>{errorListEntries}</ul>
    </Alert>
  );
}
